import { render, staticRenderFns } from "./CampaignDetailsForm.vue?vue&type=template&id=4f9231d9&"
import script from "./CampaignDetailsForm.vue?vue&type=script&lang=js&"
export * from "./CampaignDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports